import server from "../Server";
import withErrorCheck from "../CheckError";
import { GetPlayerGroupsPayload } from "@grassrootly/api/gateways/player/GetPlayerGroups";
import { IPlayerGroup } from "@grassrootly/api/entities";

export const GetPlayerGroups = async (payload: GetPlayerGroupsPayload): Promise<IPlayerGroup[]> => {
  if (!payload.playerId) {
    return [];
  }
  const groupMappers = withErrorCheck(await server.from("GroupPlayers").select("*").eq("player_id", payload.playerId));
  const groups = withErrorCheck(
    await server
      .from("Groups")
      .select("*")
      .in(
        "id",
        groupMappers.map((g) => g.group_id)
      )
  );

  return groups.map((g) => ({ ...g, is_owner: !!groupMappers.find((gm) => gm.group_id === g.id)?.is_owner }));
};
